import { render } from "./home.vue?vue&type=template&id=37275638&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=37275638&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-37275638"

export default script